
/*
Defines the custom element <ravel-fluxum>
*/

import { RavelFluxum } from './src/RavelFluxum.js';

customElements.define('ravel-fluxum', RavelFluxum);
